import { AnyAction, combineReducers } from 'redux';
import {
  reducer as oidcReducer,
  SESSION_TERMINATED,
  SILENT_RENEW_ERROR,
  USER_EXPIRED,
  USER_SIGNED_OUT,
} from 'redux-oidc';
import { USER_LOGOUT } from 'src/shared/services/redux/constants/userTypes';
import authReducer from './authReducer';
import TagsReducer from './tagsReducer';
import BusinessAreaReducer from './businessAreaReducer';
import PermissionsReducer from './permissionsReducer';
import MenuListReducer from './menuListReducer';
import NotificationReducer from './notificationReducer';

const appReducer = combineReducers({
  oidc: oidcReducer,
  authState: authReducer,
  tagsReducer: TagsReducer,
  notificationReducer: NotificationReducer,
  businessAreaReducer: BusinessAreaReducer,
  permissionsReducer: PermissionsReducer,
  MenuListReducer,
});

const oidcSessionEndedActions = [
  SESSION_TERMINATED,
  SILENT_RENEW_ERROR,
  USER_EXPIRED,
  USER_SIGNED_OUT,
];

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction,
) => {
  const nextState = appReducer(state, action);

  if (oidcSessionEndedActions.includes(action.type)) {
    return {
      ...nextState,
      authState: authReducer(undefined, { type: USER_LOGOUT }),
    };
  }

  return nextState;
};

export default rootReducer;

export type RootStateType = ReturnType<typeof appReducer>;
